export default "__VITE_ASSET__D5taG$qi__"